import { createContext } from 'react';

export type TaskListSearchContextProps = {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
};

export const TaskListSearchContext = createContext<TaskListSearchContextProps>({
  searchQuery: '',
  setSearchQuery: () => {},
});
